import React from 'react';
import ListAppsContainer from '@src/containers/ListApps';

const ListApps = () => <ListAppsContainer />;

export default ListApps;
